











import { Component, Vue } from 'vue-property-decorator'
import { VQuery, VTable, QueryModel, TableHander, TableOperation } from '@/components/table'
import { QueryInformationList, DeleteInformation } from '@/api'
import { DateFormat } from '@/utils/date/DateUtil'
import { Message, MessageBox } from 'element-ui'
import router from '@/router'
import constant from '@/utils/constant'
import { InformationTypeFormat } from '@/utils/tyepconvert'
import CreateInformationDialog from './CreateInformationDialog.vue'
import UpdateInformationDialog from './UpdateInformationDialog.vue'

@Component({
  components: {
    VQuery,
    VTable,
    CreateInformationDialog,
    UpdateInformationDialog,
  },
})
export default class InformationList extends Vue {
  private queryParam = {
    startRow: 1,
    limit: 10,
    sortType: 0,
  }
  private tableTotal = 0
  private tableData = []
  private tableCurrntPage = 1

  // 查询条件
  private queryModels: Array<QueryModel> = [
    { title: '排序方式', param: 'sortType' , type: 'select', selectData: constant.SortType},
    { title: '分类', param: 'type', type: 'select', selectData: constant.InformationType },
    { title: '标题', param: 'title' },
  ]
  // 全局操作
  private queryOperation: Array<TableOperation> = [{ title: '创建', type: 'primary', click: this.create }]
  // 数据表头
  private tableHander: Array<TableHander> = [
    { title: '序号', param: 'id' },
    { title: '分类', param: 'type', formatter: InformationTypeFormat },
    { title: '标题', param: 'title' },
    { title: '排序', param: 'sort' },
    { title: '创建时间', param: 'createTime', formatter: DateFormat },
    {
      title: '操作',
      width: 180,
      operation: [
        { title: '编辑', icon: 'el-icon-document', click: this.openEdit },
        { title: '删除', icon: 'el-icon-delete', class: 'red', click: this.deleteRow },
      ],
    },
  ]

  public async created() {
    this.loadData()
  }

  public create() {
    const d = this.$refs.CreateInformationDialog as CreateInformationDialog
    d.open()
  }
  public openEdit(data: any) {
    const d = this.$refs.UpdateInformationDialog as UpdateInformationDialog
    d.open({ id: data.id })
  }

  public async loadData() {
    const param: any = { ...this.queryParam }
    if(this.queryParam.sortType == 0){
      param.orderBy = "sort desc, create_time desc"
    }
    param.startRow =  (this.tableCurrntPage - 1) * (param.limit || 12)
    const result = await QueryInformationList(param)
    this.tableTotal = result.total
    this.tableData = result.list
  }

  public search() {
    this.tableCurrntPage = 1
    this.loadData()
  }
  // 分页导航改变
  public pageChange(index: number) {
    this.tableCurrntPage = index
    this.loadData()
  }

  public sizeChange(index: number) {
    this.tableCurrntPage = 1
    this.queryParam.limit = index
    this.loadData()
  }

  // 删除单行数据
  public deleteRow(data: any) {
    MessageBox.confirm('确定要删除吗？', '提示', {
      type: 'warning',
    }).then(async () => {
      const ruslt = await DeleteInformation({ id: data.id })
      if (ruslt) {
        Message.success('删除成功')
        this.loadData()
      }
    })
  }

  private xcxUrl(value: string) {
    return '/pages/show/show?id=' + value
  }
}
